import * as types from './action-types';

const defaultState = {
    hasError: false,
    error: null,
    denialReasons: [],
    fetchingDenialReasons: false,
    canReapply: false,
    reapplicationDate: null,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.FETCHING_DENIAL_REASONS:
        return Object.assign({}, state, {
            hasError: true,
            error: null,
            fetchingDenialReasons: true,
        });
    case types.SUCCESSFULLY_RECEIVED_DENIAL_REASONS:
        return Object.assign({}, state, {
            hasError: false,
            error: null,
            fetchingDenialReasons: false,
            denialReasons: action.denialReasons,
            canReapply: action.canReapply,
            reapplicationDate: action.reapplicationDate,
        });
    case types.FAILED_FETCHING_DENIAL_REASONS:
        return Object.assign({}, state, {
            hasError: true,
            error: action.error,
            fetchingDenialReasons: false,
            denialReasons: [],
            canReapply: false,
            reapplicationDate: null,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
